type SimulatedKeyEvent = KeyboardEvent & { isSimulated?: boolean };
export type DirectionsType = 'Left' | 'Right' | 'Up' | 'Down';

export function getSimulatedKeyEvent(event: KeyboardEvent): SimulatedKeyEvent {
  // In some cases, we need to know if its a manually generated key event to differentiate handling
  (event as SimulatedKeyEvent).isSimulated = true;
  return event;
}

export function isKeySimulated(event?: SimulatedKeyEvent) {
  return event?.isSimulated;
}

export function getSimulatedKeyEventFromMap(
  keyMap: Record<number, string>,
  keyName: string,
): SimulatedKeyEvent {
  const keyCode = Number(
    Object.keys(keyMap).find(key => keyMap[Number(key)] === keyName),
  );

  const keyEvent = new KeyboardEvent('keydown', {
    key: keyName,
    code: keyName,
    bubbles: true,
    cancelable: true,
  });

  // For some devices keyCode/which are always set to 0 due to being deprecated.
  // Setting with defineProperty guarantees the actual value to be stored.
  Object.defineProperty(keyEvent, 'keyCode', { value: keyCode });
  Object.defineProperty(keyEvent, 'which', { value: keyCode });

  (keyEvent as SimulatedKeyEvent).isSimulated = true;

  return keyEvent;
}

export function isHorizontalDirection(direction: DirectionsType) {
  return direction === 'Left' || direction === 'Right';
}

export function isVerticalDirection(direction: DirectionsType) {
  return direction === 'Up' || direction === 'Down';
}
